module.exports = __webpack_public_path__ + "static/img/title.bbd5591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/title.jpg
// module id = 387
// module chunks = 1